<template>
  <div class="container">
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        loading-text="Φόρτωση καρτελών..."
        no-data-text="Δεν υπάρχουν δεδομένα"
        sort-by="calories"
        class="elevation-1"
        disable-pagination
        disable-filtering
        hide-default-footer>
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Καρτέλες</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>


          <v-dialog v-model="ledgerDialogOpen">
            <v-card>
              <v-card-title class="text-h5">Καρτέλα</v-card-title>
              <v-card-text>
                <v-data-table
                    v-bind:items="currentLedger.entries"
                    v-bind:headers="ledgerHeaders"
                    :loading="loadingLedger"
                    loading-text="Φόρτωση κινήσεων καρτέλας..."
                    no-data-text="Δεν υπάρχουν κινήσεις"
                    disable-pagination
                    disable-filtering
                    disable-sorting
                    
                    >
                  <template v-slot:[`item.debit`]="{ item }">
                    <span>{{ formatMoney(item.debit) }}</span>
                  </template>
                  <template v-slot:[`item.credit`]="{ item }">
                    <span>{{ formatMoney(item.credit) }}</span>
                  </template>
                  <template v-slot:[`item.oldBalance`]="{ item }">
                    <span>{{ formatMoney(item.oldBalance) }}</span>
                  </template>  
                  <template v-slot:[`item.newBalance`]="{ item }">
                    <span>{{ formatMoney(item.newBalance) }}</span>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div v-if="item.printUrl" class="text-no-wrap">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="printDocument(item)"
                          >
                            <v-icon small>mdi-printer</v-icon>
                          </v-btn>
                        </template>
                        <span>Εκτύπωση παραστατικού</span>
                      </v-tooltip>

                      <v-tooltip bottom v-if="item.mailerUrl">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            small
                            color="indigo"
                            v-bind="attrs"
                            v-on="on"
                            @click="openDocumentMailDialog(item)"
                          >
                            <v-icon small>mdi-email</v-icon>
                          </v-btn>
                        </template>
                        <span>Αποστολή με email</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDocumentMail" max-width="500px">
            <v-card>
              <v-card-title class="text-h6 d-flex align-center">
                <v-icon left color="primary" class="mr-2">mdi-email-send</v-icon>
                Αποστολή παραστατικού με email
              </v-card-title>
              <v-card-subtitle class="mt-1 pb-1" v-if="selectedDocumentForMail">
                <strong>{{ selectedDocumentForMail.documentTypeDescription }}</strong> {{ selectedDocumentForMail.documentNumber ? '(Αρ. ' + selectedDocumentForMail.documentNumber + ')' : '' }}
              </v-card-subtitle>
              <v-card-text>
                <v-text-field 
                  v-model="documentMailRecipient"
                  label="Διεύθυνση αποστολής"
                  hint="Για πολλαπλά email διαχωρίστε με ; (π.χ. email1@test.gr; email2@test.gr)"
                  persistent-hint
                  outlined
                  dense
                  class="mt-2"
                >
                </v-text-field>
              </v-card-text>
              <v-card-actions class="pb-4 px-4">
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text @click="closeDocumentMail">ΑΚΥΡΟ</v-btn>
                <v-btn 
                  color="success" 
                  rounded
                  elevation="2"
                  class="px-4 font-weight-bold white--text"
                  @click="sendDocumentMailConfirm" 
                  :loading="documentMailLoading"
                >
                  <v-icon left small>mdi-send</v-icon>
                  ΑΠΟΣΤΟΛΗ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn text color="primary" class="mr-2" @click="showLedgerFor(item)"> ΚΑΡΤΕΛΑ </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      headers: [
        {
          text: 'Επωνυμία',
          align: 'start',
          //sortable: false,
          value: 'name',
        },
        { 
          text: 'ΑΦΜ', 
          value: 'tax_registration_number' 
        },
        { 
          text: 'Υπόλοιπο', 
          value: 'balance' 
        },
        { 
            text: 'Actions', 
            value: 'actions', 
            sortable: false 
        },
      ],

        ledgerHeaders: [
        {
            text: 'Ημερομηνία',
            value: 'date'
        },
        {
            text: 'Παραστατικό',
            value: 'documentTypeDescription'
        },
        {
            text: 'Αριθμός',
            value: 'documentNumber'
        },
        {
            text: 'Χρέωση',
            value: 'debit',
            align: 'right'
        },
        {
            text: 'Πίστωση',
            value: 'credit',
            align: 'right'
        },
        {
            text: 'Παλιό υπόλοιπο',
            value: 'oldBalance',
            align: 'right'
        },
        {
            text: 'Νέο υπόλοιπο',
            value: 'newBalance',
            align: 'right',
            class: 'font-bold'
        },
        {
            text: 'Ενέργειες',
            align: 'center',
            value: 'actions',
            sortable: false,
            width: '110px'
        },
    ],

      loading: true,
      loadingLedger: false,
      dialogDocumentMail: false,
      selectedDocumentForMail: null,
      documentMailRecipient: '',
      documentMailLoading: false,
      selectedAccountForLedger: null,
      items: [],
      currentLedger: {},

      openLedgerButtonDisabled: false,
      ledgerDialogOpen: false,
    }),


    created () {
      this.initialize()
    },

    methods: {
      printDocument(item) {
        if (!item.printUrl) {
          if (this.$swal) this.$swal.fire('Προσοχή', 'Δεν υπάρχει διαθέσιμο εκτυπωτικό για τη γραμμή αυτή.', 'warning');
          return;
        }
        window.open(item.printUrl, '_blank').focus();
      },

      openDocumentMailDialog(item) {
        this.selectedDocumentForMail = item;
        this.documentMailRecipient = item.recipientEmail || this.selectedAccountForLedger?.email || '';
        this.dialogDocumentMail = true;
      },

      closeDocumentMail() {
        this.dialogDocumentMail = false;
        this.selectedDocumentForMail = null;
        this.documentMailRecipient = '';
      },

      sendDocumentMailConfirm() {
        if (!this.selectedDocumentForMail || !this.selectedDocumentForMail.mailerUrl) return;
        if (!this.documentMailRecipient || !this.documentMailRecipient.trim()) {
          if (this.$swal) this.$swal.fire('Προσοχή', 'Παρακαλώ συμπληρώστε διεύθυνση email.', 'warning');
          return;
        }

        this.documentMailLoading = true;
        axios.post(this.selectedDocumentForMail.mailerUrl, {
          document_id: this.selectedDocumentForMail.documentId,
          email_address: this.documentMailRecipient
        }).then(response => {
          if (this.$swal) {
            this.$swal.fire('Επιτυχία', 'Το παραστατικό απεστάλη επιτυχώς με email.', 'success');
          }
          this.closeDocumentMail();
        }).catch(error => {
          console.error(error);
          let msg = 'Σφάλμα κατά την αποστολή του email.';
          if (error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
          }
          if (this.$swal) {
            this.$swal.fire('Σφάλμα', msg, 'error');
          }
        }).finally(() => {
          this.documentMailLoading = false;
        });
      },

      formatMoney(amount) {
        if (amount == null)
          amount = 0.0

        return amount.toFixed(2)
      },
      initialize () {
        this.loading = true;
        
        axios.get('/api/accounts/active')
        .then(response => { this.items = response.data })
        .catch(error => { console.log(error) })

      },

      showLedgerFor(account) {
          this.selectedAccountForLedger = account;
          this.loadingLedger = true;
          axios.get(`/api/accounts/${account.id}/ledger`)
          .then(response => { this.currentLedger = response.data; this.ledgerDialogOpen = true })
          .catch(error => { console.log(error) })
      }
 
    },
  }
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}

th {
  vertical-align: top;
}
</style>